import { Component, OnInit } from '@angular/core';
import { RestService } from "app/webservice/rest.service";
import { GridMetadataService } from '../clearwave-grid/grid.metadata.service';
import { environment } from "environments/environment";
import { Router } from '@angular/router';
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {
  
  public loading: boolean = false;
  public serviceStackUrl;
  public lateAssetsDetailIsEmpty: boolean = false;
  public lateAssets;
  public lateAssetsDetail;
  
  constructor(
    private _restService: RestService, 
    private _gridMetadataService: GridMetadataService,
    platformLocation: PlatformLocation
  ) {
    this.loading = true;
    
    this.serviceStackUrl = (platformLocation as any).location.origin + '/CCLibrary/api/';
    
    this.lateAssets = this._gridMetadataService.describe('LateAssets', null);
    this.lateAssets.title = 'Checked Out Assets (Late)';
    this.lateAssets.forceFitColumns = true;
    this.lateAssets.height = -825;
    this.lateAssets.completeGridEditDisabled = true;
    this.lateAssets.disableRest = true;
    this.lateAssets.onClick = this.lateAssetsRowClick.bind(this);
    
    this.lateAssetsDetail = this._gridMetadataService.describe('LateAssetsDetail', null);
    this.lateAssetsDetail.forceFitColumns = true;
    this.lateAssetsDetail.height = -525;
    this.lateAssetsDetail.completeGridEditDisabled = true;
    this.lateAssetsDetail.disableRest = true;
    
    this.GetAgedCheckoutHistory();
  }

  ngOnInit() {
  
  }

  GetAgedCheckoutHistory() {
    let url = this.serviceStackUrl +  'Asset-GetAgedCheckoutHistory';
    this._restService.post(url, {}).then(response => {
      console.log(response);
      this.loading = false;
      response.Data.Data.forEach((m,i)=>m['Oid']=i);
      for (var i = response.Data.Data.length - 1; i >= 0; i--) {
        if (response.Data.Data[i].Name === "Audio") {
          response.Data.Data.splice(i, 1);
        }
      }

      this.lateAssets.setData(response.Data.Data);
      if (response.Data.Data[0].CheckoutHistory.length) {
        this.lateAssetsDetailIsEmpty = false;
      } else {
        this.lateAssetsDetailIsEmpty = true;
      }
      this.lateAssetsDetail.title = 'Late ' + response.Data.Data[0].Name + ' Detail - ' + response.Data.Data[0].CheckoutHistory.length + ' entries';
      if (typeof this.lateAssetsDetail.setData === "function") {
        this.lateAssetsDetail.setData(response.Data.Data[0].CheckoutHistory);
      } else {
        this.lateAssetsDetail.data = response.Data.Data[0].CheckoutHistory;
      }
      
    });
  }

  lateAssetsRowClick (e, args, row) {
    console.log(row);
    
    if (row.CheckoutHistory.length) {
      this.lateAssetsDetailIsEmpty = false;
    } else {
      this.lateAssetsDetailIsEmpty = true;
    }
    this.lateAssetsDetail.title = 'Late ' + row.Name + ' Detail - ' + row.CheckoutHistory.length + ' entries';
    this.lateAssetsDetail.setData(row.CheckoutHistory);
    this.lateAssetsDetail.data = row.CheckoutHistory;
  }
}



// WEBPACK FOOTER //
// c:/Projects/CCLibrary/Client/src/app/history/history.component.ts